import React from 'react';

export const Tab = ({ title, count }: { title: string; count?: number }) => (
  <div className="TabTitle">
    {count !== undefined && <div className="length">{count}</div>}
    <div className="title">{title}</div>
    <style jsx>{`
      .TabTitle {
        padding: 0 16px;
      }
      .title {
        text-align: center;
        font-weight: 900;
        text-transform: uppercase;
        min-width: 48px;
        font-style: normal;
        line-height: 20px;
      }
      .length {
        text-align: center;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 32px;
        margin-bottom: 8px;
      }
    `}</style>
  </div>
);
